import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";
import SEOHead from "@/components/feature/SEOHead";
import Breadcrumb from "@/components/feature/Breadcrumb";
import SchemaOrg from "@/components/feature/SchemaOrg";
import { StructuredData } from "@/mocks/schema";

export default function AboutPage() {
  return (
    <>
      <SEOHead
        title="关于我们"
        description={`${siteInfo.name}致力于为用户提供全面、准确、及时的91直播平台相关信息。了解我们的品牌介绍、信誉与联系方式。`}
        keywords="91直播平台, 关于我们, 品牌介绍, 联系方式, 平台信誉"
      />
      <SchemaOrg data={StructuredData.organization} />

      <div className="pt-16">
        <Breadcrumb items={[{ label: "关于我们" }]} />

        {/* Hero Banner */}
        <section className="w-full py-14 md:py-20 bg-background-100">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-3xl mx-auto text-center">
              <h1 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
                关于我们
              </h1>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl mx-auto">
                {siteInfo.name}致力于为用户提供全面、准确、及时的91直播平台相关信息。在信息繁杂的网络环境中，帮助用户识别真伪、规避风险、安心使用。
              </p>
            </div>
          </div>
        </section>

        {/* Brand Introduction */}
        <section className="w-full py-14 md:py-20 bg-background-50">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-6">
                品牌介绍
              </h2>
              <div className="prose-content text-sm md:text-base text-foreground-700 leading-relaxed space-y-4"
                dangerouslySetInnerHTML={{ __html: siteInfo.aboutUs.content }}
              />
            </div>
          </div>
        </section>

        {/* Reputation */}
        <section className="w-full py-14 md:py-20 bg-background-100">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-5xl mx-auto">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-10 text-center">
                {siteInfo.aboutUs.reputation.title}
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {siteInfo.aboutUs.reputation.items.map((item, index) => (
                  <div
                    key={index}
                    className="bg-background-50 rounded-lg border border-background-200/70 p-6 text-center"
                  >
                    <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-100/80">
                      <i className={`${item.icon} text-xl text-accent-700`}></i>
                    </div>
                    <h3 className="text-base font-semibold text-foreground-950 mb-2">
                      {item.title}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="w-full py-14 md:py-20 bg-background-50">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-10 text-center">
                {siteInfo.aboutUs.contact.title}
              </h2>
              <div className="bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-8">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 flex items-center justify-center flex-shrink-0 rounded-md bg-accent-100/80 mt-0.5">
                      <i className="ri-mail-line text-accent-700"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-950 mb-1">
                        电子邮箱
                      </p>
                      <p className="text-sm text-foreground-600">
                        {siteInfo.aboutUs.contact.email}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 flex items-center justify-center flex-shrink-0 rounded-md bg-accent-100/80 mt-0.5">
                      <i className="ri-wechat-line text-accent-700"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-950 mb-1">
                        微信
                      </p>
                      <p className="text-sm text-foreground-600">
                        {siteInfo.aboutUs.contact.wechat}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 flex items-center justify-center flex-shrink-0 rounded-md bg-accent-100/80 mt-0.5">
                      <i className="ri-qq-line text-accent-700"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-950 mb-1">
                        QQ
                      </p>
                      <p className="text-sm text-foreground-600">
                        {siteInfo.aboutUs.contact.qq}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 flex items-center justify-center flex-shrink-0 rounded-md bg-accent-100/80 mt-0.5">
                      <i className="ri-time-line text-accent-700"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-950 mb-1">
                        工作时间
                      </p>
                      <p className="text-sm text-foreground-600">
                        {siteInfo.aboutUs.contact.workingHours}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Disclaimer */}
                <div className="mt-8 pt-6 border-t border-background-200/70">
                  <h3 className="text-sm font-semibold text-foreground-950 mb-2">
                    免责声明
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    本站为第三方资讯整理平台，内容来源于公开信息整理及用户经验分享，所有内容仅供参考。访问或下载91直播平台相关应用前，请务必确认来源可靠。使用过程中如遇到任何问题，请通过官方渠道核实。请遵守当地法律法规，本站不对因使用本站信息而产生的任何后果承担责任。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Quick Links */}
        <section className="w-full py-10 md:py-14 bg-background-100">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-3xl mx-auto text-center">
              <h2 className="text-lg md:text-xl font-bold text-foreground-950 mb-6">
                快速导航
              </h2>
              <div className="flex flex-wrap items-center justify-center gap-3">
                <Link
                  to="/"
                  className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-50 border border-background-200/70 rounded-md text-sm text-foreground-700 hover:text-primary-500 hover:border-primary-200 transition-colors whitespace-nowrap"
                >
                  <i className="ri-home-line"></i>
                  返回首页
                </Link>
                <Link
                  to="/category/zixun"
                  className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-50 border border-background-200/70 rounded-md text-sm text-foreground-700 hover:text-primary-500 hover:border-primary-200 transition-colors whitespace-nowrap"
                >
                  <i className="ri-newspaper-line"></i>
                  相关资讯
                </Link>
                <Link
                  to="/category/anquan"
                  className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-50 border border-background-200/70 rounded-md text-sm text-foreground-700 hover:text-primary-500 hover:border-primary-200 transition-colors whitespace-nowrap"
                >
                  <i className="ri-shield-check-line"></i>
                  安全提示
                </Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}